export function isSuccessfulStatusCode(status: number): boolean {
  return status >= 200 && status < 300;
}

export function isErrorStatusCode(status: number): boolean {
  return status >= 400 && status < 500;
}

export function isTimeoutStatusCode(status: number): boolean {
  return status >= 500 && status < 600;
}
